module.exports = __webpack_public_path__ + "static/img/wj.6a59a03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wj.png
// module id = uAl9
// module chunks = 1